var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1252 9.26469C21.1252 11.4259 19.4947 13.0564 17.3335 13.0564C15.1722 13.0564 13.5418 11.4259 13.5418 9.26469C13.5418 7.10344 15.1722 5.47302 17.3335 5.47302C19.4947 5.47302 21.1252 7.10344 21.1252 9.26469ZM5.41683 8.66669H7.5835V11.9167H10.8335V14.0834H7.5835V17.3334H5.41683V14.0834H2.16683V11.9167H5.41683V8.66669ZM21.6668 20.5834H10.8335V19.5C10.8335 16.5133 13.2634 14.0834 16.2502 14.0834H18.4168C21.4036 14.0834 23.8335 16.5133 23.8335 19.5V20.5834H21.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.9cc845d2696a4260607331044be40bd1.svg";
export { ForwardRef as ReactComponent };